module.exports = __webpack_public_path__ + "static/media/location_black_icon.37a87bb4.svg";